import React, { useEffect, useState } from "react";
import axios from "axios";
import NoListProv from "./NoListComer/NoListComer";
import "./ListProvComer.css";
import { FaClipboardList } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import NavbarComercializador from "../NavbarSupplier/NavbarSupplier";
import FooterIndex from "../../components/footerHomePage/footerHomePage";

const ListProv = () => {
  const [salesData, setSalesData] = useState(null);
  const [load, setLoad] = useState(true);
  const location = useLocation();
  let data = location.state;

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  useEffect(() => {
    setLoad(true);
    const id = data.id;
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BRING_SEARCH_INVOICE_COMERCIALIZADOR}?id=${id}`
        );
        if (response.status === 204) {
          setLoad(false);
          setSalesData(null);
        } else {
          setLoad(false);
          setSalesData(response.data.invoiceValue);
        }
      } catch (error) {
        setLoad(false);
        setSalesData(null);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div>
        <NavbarComercializador />

        {!load ? (
          <>
            {salesData !== null ? (
              <div>
                <div className="backgounrdprovee">
                  <div className="allboxlistprov">
                    <div className="alllistprov">
                      <div className="headerlistprov">
                        <p className="infoprovlistletter leftlistprev firsttittle">
                          Mes
                        </p>
                        <p className="infoprovlistletter leftlistprev">
                          Nº Factura
                        </p>
                        <p className="infoprovlistletter leftlistprev">Total</p>
                        <p className="infoprovlistletter leftlistprev">CBU</p>
                        <p className="infoprovlistletter leftlistprev">
                          Observaciones
                        </p>
                        <p className="infoprovlistletter leftlistprev lastittle">
                          Estado
                        </p>
                      </div>

                      {salesData &&
                        salesData.map((sale, index) => (
                          <div className="headerlistprov" key={index}>
                            <p className="infoprovlistletter leftlistprev2 firsttittle">
                              {sale.month}
                            </p>
                            <p className="infoprovlistletter bottonlistprev2">
                              {sale.numberInvoice}
                            </p>
                            <p className="infoprovlistletter leftlistprev2">
                              ${sale.amountToBeTransferred}
                            </p>
                            <p className="infoprovlistletter leftlistprev2">
                              {sale.cbu}
                            </p>
                            <p className="infoprovlistletter leftlistprev2">
                              {sale.observation}
                            </p>
                            <p className="infoprovlistletter leftlistprev2">
                              {sale.invoice}
                            </p>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <NoListProv
                title="La información de este mes no se ha subido aún."
                Icon={FaClipboardList}
              />
            )}
            <FooterIndex />
          </>
        ) : (
          <div className="loader"></div>
        )}
      </div>
    </>
  );
};

export default ListProv;
